import {useEffect, useState} from "react";
import {getAll as getRecords} from "app/requests/admin/pages";
import Loading from "components/pages/loading";
import Row from "./row";

export default function AdminPagesList() {
  const [records, setRecords] = useState(null);
  const onDestroy = (id) => {
    setRecords(records.filter((record) => record.id !== id));
  };

  useEffect(() => {
    getRecords().then((data) => setRecords(data.pages));
  }, []);

  if(!records) { return <Loading />; }

  return (
    <div className="max-w-screen-lg mx-auto">
      <h1 className="text-center">Pages</h1>
      <div className="text-right mb-1">
        <a className="btn btn-outline-black btn-sm" href="/admin/pages/new">New Page</a>
      </div>
      <div className="table-responsive">
        <table className="table text-center">
          <thead>
            <tr>
              <th>Active</th>
              <th>Rank</th>
              <th>Template</th>
              <th>Name</th>
              <th>Path</th>
              <th>Created At</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {records.map((record) => (
              <Row key={record.id} onDestroy={onDestroy} record={record} />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
